// src/pages/PropertyDetail.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { properties, developers, locations } from '@/data/mock';

const PropertyDetail = () => {
  const { id } = useParams();

  const property = properties.find((item) => item.id === id);

  if (!property) {
    return (
      <div className="p-8">
        <h1>Property not found</h1>
      </div>
    );
  }

  const developer = developers.find(
    (d) => d.id === property.developer
  );


  const location = locations.find(
    (l) => l.id === property.location
  );

  return (
    <div className="max-w-6xl mx-auto p-6">
      <img
        src={property.image}
        alt={property.name_en}
        className="w-full h-[450px] object-cover rounded-xl"
      />

      <div className="mt-6">
        <h1 className="text-4xl font-bold">
          {property.name_en}
        </h1>

        <p className="text-gray-600 mt-2">
          {developer?.name} • {location?.name_en}
        </p>

        <div className="mt-6 space-y-2">
          <p>
            <strong>Starting Price:</strong>{' '}
            AED {property.startingPrice.toLocaleString()}
          </p>

          <p>
            <strong>Bedrooms:</strong> {property.bedrooms}
          </p>

          <p>
            <strong>ROI:</strong> {property.roi}
          </p>

          <p>
            <strong>Handover:</strong> {property.handover}
          </p>

          <p>
            <strong>Payment Plan:</strong>{' '}
            {property.paymentPlan}
          </p>
        </div>

        <div className="mt-8">
          <h2 className="text-2xl font-semibold">
            Overview
          </h2>

          <p className="mt-3 text-gray-700">
            {property.overview_en}
          </p>
        </div>

        {property.gallery?.length > 0 && (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
            {property.gallery.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${property.name_en}-${index}`}
                className="rounded-lg h-56 w-full object-cover"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyDetail;